import React from 'react';
import { Pagination } from '@gerdau/hefesto-mais-web';
import { SearchOptionsProps } from '../../../../services/MVP/models';
import { PaginationContainer } from '../ShoppingCartMVP/style';
import { EmptyCatalog } from './EmptyCatalog';

export const CatalogPagination = ({
  handleSearchChange,
  handleChange,
  catalogFilters,
  productsLength,
  total,
  selectedPage
}: {
  handleSearchChange: (
    value: SearchOptionsProps['filters']
  ) => Promise<void | null>;
  handleChange: ({
    currentPage,
    pageSize
  }: {
    currentPage?: number;
    pageSize?: number;
  }) => void;
  catalogFilters: SearchOptionsProps['filters'];
  productsLength: number;
  total: number;
  selectedPage: number;
}) => {
  const hasFiltered =
    catalogFilters.input !== '' ||
    (catalogFilters.productsTypes &&
      catalogFilters.productsTypes.filter((el) => el.length > 0).length > 0);

  if (productsLength === 0) {
    if (hasFiltered) {
      return <EmptyCatalog handleSearchChange={handleSearchChange} />;
    }

    return null;
  }

  return (
    <PaginationContainer disableNextPage={total <= 12}>
      <Pagination
        key={JSON.stringify({
          input: catalogFilters.input,
          ordenation: catalogFilters.ordenation,
          productsTypes: catalogFilters.productsTypes
        })}
        ariaLabel="pagination"
        onChange={(page: number, pageTotal: number) =>
          total <= 12
            ? null
            : handleChange({
                currentPage: Math.ceil(page),
                pageSize: pageTotal
              })
        }
        total={total}
        showTotal
        selectedPage={selectedPage}
        pageSizeOptions={[12, 24]}
      />
    </PaginationContainer>
  );
};
